import React from 'react'
import QuantityControl from './QuantityControl'
import { formatPrice } from '../utils/formatters'

// Unit price of a basket line: server-enriched lines carry unit_price_pence
// (base + chosen add-on deltas); a plain line (e.g. checkout upsell) has none,
// so fall back to price_pence.
const lineUnitPrice = (item) => item.unit_price_pence ?? item.price_pence

export default function OrderSummary({ basket, total, onUpdateQuantity, editable = false }) {
  return (
    <section className="bg-white rounded-xl p-6" aria-label="Order summary">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Order Summary</h2>

      <ul className="space-y-3">
        {Object.entries(basket).map(([key, item]) => {
          const unitPrice = lineUnitPrice(item)
          const addOns = item.selected_add_ons || []
          return (
            <li key={key} className="flex items-center justify-between py-3 border-b last:border-b-0">
              <div className="flex-1 min-w-0 pr-4">
                <div className="text-gray-900 font-medium truncate">{item.name}</div>
                {addOns.length > 0 && (
                  <ul className="text-xs text-gray-500 mt-0.5 space-y-0.5">
                    {addOns.map(a => (
                      <li key={a.id}>+ {a.name}</li>
                    ))}
                  </ul>
                )}
                <div className="text-sm text-gray-600 mt-0.5">
                  {formatPrice(unitPrice)} each
                </div>
              </div>

              {editable && onUpdateQuantity ? (
                <div className="flex items-center gap-2">
                  <QuantityControl
                    quantity={item.quantity}
                    onIncrease={() => onUpdateQuantity(key, item.quantity + 1)}
                    onDecrease={() => onUpdateQuantity(key, item.quantity - 1)}
                    itemName={item.name}
                  />
                  <span className="font-semibold text-gray-900 min-w-[60px] text-right ml-2">
                    {formatPrice(unitPrice * item.quantity)}
                  </span>
                </div>
              ) : (
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-gray-600">
                    {item.quantity}x
                  </span>
                  <span className="font-semibold text-gray-900 min-w-[60px] text-right">
                    {formatPrice(unitPrice * item.quantity)}
                  </span>
                </div>
              )}
            </li>
          )
        })}
      </ul>

      <div className="flex justify-between pt-4 mt-4 font-bold text-lg border-t-2">
        <span>Total</span>
        <span className="text-sky-900">{formatPrice(total)}</span>
      </div>
    </section>
  )
}
